import { render, staticRenderFns } from "./FormToggleInput.vue?vue&type=template&id=1172a561&"
import script from "./FormToggleInput.vue?vue&type=script&lang=js&"
export * from "./FormToggleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports